"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _tiktok = _interopRequireDefault(require("./tiktok.theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var tiktok = {
  app: {
    atomicPublisherUnit: "user",
    atomicFollowerUnit: "follower"
  },
  brand: {
    codename: "tiktok",
    name: "TikTok",
    theme: _tiktok["default"].tenant.primary,
    logoProps: {
      name: "tiktokLogo"
    }
  },
  reporting: {
    pageTitle: "DV Intelligence",
    apiService: "configReportingService",
    pollingInterval: 5000,
    headerColor: "berry",
    headerIcon: "chart",
    hasSearch: true,
    wizard: {
      report_type: "tt_video_impressions",
      button: {
        text: "Create Report",
        variant: "outlined"
      },
      component: "CampaignPicker",
      source: "/campaigns",
      steps: ["campaigns", "dates", "confirm"]
    },
    catalog: {
      source: "/reports",
      defaultSortParam: "-modified",
      extraParams: {
        report_type: "tt_video_impressions"
      },
      defaultAggregates: {
        modified_by__username: []
      },
      toolbar: {
        fetchAggregates: true,
        // If application uses SOLR, this is not needed
        // Otherwise this will map an individual param to an endpoint request
        // Could be updated to incorporate an array
        aggregateRequests: [{
          name: "modified_by__username",
          endpoint: "/reports/modified_by",
          getDisplayNames: function getDisplayNames(options) {
            var defaultUserName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Report Bot";
            var updatedOptions = options.map(function (user) {
              var fullName = user.email === "" ? user.fullName = defaultUserName : "".concat(user.first_name, " ").concat(user.last_name);
              return _objectSpread(_objectSpread({}, user), {}, {
                fullName: fullName
              });
            });
            return updatedOptions;
          }
        }],
        filters: [{
          component: "splitDate",
          key: "modified__range__split",
          end_name: "modified__lte",
          start_name: "modified__gte",
          withTime: true
        }, {
          component: "select",
          name: "modified_by__username",
          matchKey: "username",
          displayKey: "fullName",
          label: "Modified By",
          options: true,
          labelWidth: 90
        }]
      },
      columns: [
      // TODO: How to add checkbox in the header here?
      {
        dataKey: "name",
        label: "Name",
        tableCellProps: {
          style: {
            minWidth: 200
          }
        },
        wrapWord: true
      }, {
        dataKey: "campaign_id",
        label: "Campaign ID",
        sortKey: "campaign__campaign_id",
        wrapNone: true
      }, {
        dataKey: "campaign_name",
        label: "Campaign Name",
        sortKey: "campaign__campaign_name",
        tableCellProps: {
          style: {
            minWidth: 200
          }
        },
        wrapWord: true
      }, {
        cellType: "date",
        dataKey: "start_date",
        dateFormat: "%m/%d/%y",
        sorting: false,
        label: "Start Date"
      }, {
        cellType: "date",
        dataKey: "end_date",
        dateFormat: "%m/%d/%y",
        sorting: false,
        label: "End Date"
      }, {
        cellType: "ossUserName",
        defaultValue: "Report Bot",
        dataKey: "modified_by",
        sorting: false,
        label: "Modified By"
      }, {
        cellType: "date",
        dataKey: "modified",
        dateFormat: "%m/%d/%y",
        label: "Modified Date",
        wrapNone: true
      }, {
        cellType: "reportStatus",
        label: "Status",
        sorting: false,
        dataKey: "state",
        TableCellProps: {
          align: "center",
          textAlign: "center"
        }
      }, {
        cellType: "ossActionMenu",
        actionMenuIcon: "download",
        actionMenuType: "download",
        sorting: false,
        onClick: "actionMenuClicked",
        TableCellProps: {
          align: "center",
          textAlign: "center"
        }
      }, {
        cellType: "ossActionMenu",
        actionMenuIcon: "settings",
        actionMenuType: "settings",
        onClick: "actionMenuClicked",
        sorting: false,
        TableCellProps: {
          align: "center"
        }
      }],
      actionMenus: [{
        openKey: "download",
        source: "/reports",
        tt_video_impressions: [{
          label: "PDF Report",
          path: "reports/:id/base_pdf"
        }, {
          label: "PPT Report",
          path: "reports/:id/base_ppt"
        }, {
          label: "Videos Not Verified",
          path: "reports/:id/videos_not_verified_csv"
        }, {
          label: "Report Summary CSV",
          path: "reports/:id/campaign_csv"
        }]
      }, {
        openKey: "settings",
        menuOptions: [{
          label: "Edit",
          action: "openInspector"
        }, {
          label: "Cancel",
          action: "request",
          endpoint: "/reports/:id/cancel",
          method: "post",
          success: "Report Cancelled",
          permittedConditions: ["new", "pending", "generating_metadata", "processing", "preparing", "process_queued"]
        }, {
          label: "Refresh",
          action: "request",
          endpoint: "/reports/:id/refresh",
          method: "post",
          success: "Report Refreshed",
          permittedConditions: ["ready", "published", "canceled", "error", "scheduled"]
        }, {
          label: "Delete",
          action: "delete",
          endpoint: "/reports/:id",
          method: "delete",
          success: "Report Deleted",
          permittedConditions: ["ready", "published", "canceled", "error", "scheduled"]
        }]
      }]
    },
    inspector: {
      deeplinkKey: "report_id",
      // This method parses out the required fields for editing a report
      // If a new field become editable, it would go in here
      getEditParams: function getEditParams(reportInfo) {
        return {
          campaign: reportInfo.campaign,
          name: reportInfo.name,
          start_date: reportInfo.start_date,
          end_date: reportInfo.end_date
        };
      },
      fetchMinMaxDates: {
        source: "/campaigns/:id",
        infoIdKey: "campaign",
        minDateKey: "data_start_date",
        maxDateKey: "data_end_date"
      },
      header: {
        title: "Report Info",
        deeplink: true
      },
      downloadOptions: {
        tt_video_impressions: {
          permittedConditions: ["ready", "published"],
          options: [{
            label: "PDF Report",
            path: "reports/:id/base_pdf"
          }, {
            label: "PPT Report",
            path: "reports/:id/base_ppt"
          }, {
            label: "Videos Not Verified",
            path: "reports/:id/videos_not_verified_csv"
          }, {
            label: "Report Summary CSV",
            path: "reports/:id/campaign_csv"
          }]
        }
      },
      sections: {
        summary: {
          title: "Summary Info",
          fields: [{
            objectKey: "name",
            label: "Name",
            component: "text",
            // Only fields with this value are allowed to be editable
            isEditable: function isEditable(reportInfo) {
              return (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by) && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.first_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.last_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.email) !== "";
            }
          }, {
            objectKey: "id",
            label: "Id",
            component: "text",
            copyButton: true,
            preCopyTooltip: "Copy Report Id"
          }, {
            objectKey: "modified",
            label: "Modified Date",
            component: "singleDate"
          }, {
            objectKey: "modified_by",
            label: "Modified By",
            component: "username",
            defaults: {
              first_name: "Report",
              last_name: "Bot",
              email: ""
            }
          }, {
            // Passing an array will collect the required values to be passed into the component
            objectKey: ["start_date", "end_date", "data_start_date", "data_end_date"],
            label: "Date Range",
            component: "dateRange",
            // Only fields with this value are allowed to be editable
            isEditable: function isEditable(reportInfo) {
              return (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by) && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.first_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.last_name) !== "" && (reportInfo === null || reportInfo === void 0 ? void 0 : reportInfo.created_by.email) !== "";
            }
          }, {
            component: "empty"
          }, {
            objectKey: "campaign_name",
            label: "Campaign Name",
            component: "text"
          }, {
            objectKey: "campaign_id",
            label: "Campaign ID",
            component: "text"
          }]
        },
        metrics: {
          title: "Report Metrics Info",
          fields: [{
            objectKey: ["unverified_ad_impressions", "measured_ad_impressions"],
            label: "Brand Safe Impressions",
            numType: "percent",
            component: "metric",
            // The defined keys in the above objectKey array (or individual string)
            // will be returned back to this method for custom use *
            metricMathMethod: function metricMathMethod(_ref) {
              var _ref$unverified_ad_im = _ref.unverified_ad_impressions,
                unverified_ad_impressions = _ref$unverified_ad_im === void 0 ? 0 : _ref$unverified_ad_im,
                _ref$measured_ad_impr = _ref.measured_ad_impressions,
                measured_ad_impressions = _ref$measured_ad_impr === void 0 ? 0 : _ref$measured_ad_impr;
              if (unverified_ad_impressions && measured_ad_impressions) {
                var brandSafeImpressions = Math.abs(measured_ad_impressions - unverified_ad_impressions);
                var brandSafePercentage = brandSafeImpressions / measured_ad_impressions * 100;
                return brandSafePercentage.toFixed(2); // "8.91%"
              }
              return 0;
            }
          }, {
            objectKey: "measured_ad_impressions",
            label: "Measured Ad Impressions",
            component: "metric",
            numType: "int"
          }, {
            objectKey: "spend",
            label: "Spend",
            component: "metric",
            // * Instance of an individual param being sent back to have math done
            metricMathMethod: function metricMathMethod(_ref2) {
              var _ref2$spend = _ref2.spend,
                spend = _ref2$spend === void 0 ? 0 : _ref2$spend;
              return parseFloat((spend / 100000).toFixed(2));
            } // "37,882.42"
          }, {
            objectKey: "currency_code",
            label: "Spend Currency",
            component: "text"
          }]
        },
        history: {
          title: "State History",
          objectKey: "history",
          hasSearch: true,
          searchErrors: true,
          searchErrorKey: "state",
          primarySearchKey: "history_change_reason",
          secondarySearchKey: "state",
          dataDisplayKeys: [{
            type: "state",
            title: "State",
            objectKey: "state"
          }, {
            type: "date",
            title: "Date",
            objectKey: "history_date"
          }, {
            type: "user",
            title: "User",
            objectKey: "modified_by"
          }, {
            type: "message",
            title: "Message",
            objectKey: "history_change_reason"
          }]
        }
      }
    }
  },
  navigationMenu: [{
    label: "Reports",
    iconProps: {
      name: "reports"
    },
    routeRef: "reporting",
    routeRefMatches: ["reporting"]
  }],
  routes: {
    home: {
      url: "/",
      title: "Home"
    },
    reporting: {
      component: "ConfigReporting",
      requiredPermissions: ["view_reports_catalog"],
      title: "DV Intelligence",
      url: "/reports",
      "default": true
    },
    terms: {
      component: "Terms",
      title: "DV Terms and Conditions",
      url: "/terms"
    }
  }
};
var _default = exports["default"] = tiktok;